document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.page-header' ).forEach( ( node ) => {
		const video = node.querySelector( 'video.page-header__video' );
		const button = node.querySelector( '[data-page-header-play-pause]' );

		if ( ! video || ! button ) {
			return;
		}

		const playingClass = 'page-header__play-pause--playing';

		button.addEventListener( 'click', () => {
			if ( video.paused ) {
				video.play();
				button.classList.add( playingClass );
			} else {
				video.pause();
				button.classList.remove( playingClass );
			}
		} );
	} );
} );

